import { render } from "./TalentTraining.vue?vue&type=template&id=4b601a98"
import script from "./TalentTraining.vue?vue&type=script&lang=js"
export * from "./TalentTraining.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__